export const dataTableEvents = {
  common: {
    checkedId: 'checked-item-id',
    reviewLink: 'reviewLink',
    reviewDocument: 'review-document',
    view: 'view-item',
    queryLink: 'queryLink',
    addClausesLink: 'addClausesLink',
    editProperties: 'editProperties',
    cancel: 'cancel-item',
    search: 'find-item',
    delete: 'delete-item',
    deactivate: 'deactivate-item',
    edit: 'edit-item',
    sendReport: 'send-report',
    requestSignatures: 'request-signatures',
    editInDesktop: 'edit-in-desktop-item',
    relaunchReview: 'relaunch-review-item',
    apply: 'apply-item',
    case: 'case-item',
    details: 'details-item',
    detailsField: 'details-field',
    download: 'download-item',
    calendar: 'calendar-item',
    previw: 'previw-item',
    nameClick: 'name-click',
    unlink: 'unlink',
  },
};
